const getAssetSubclassFromId = (assetSubClassId?: string, assetsSubClasses?: IAssetSubClass[]) => assetsSubClasses?.filter((c) => c.id === assetSubClassId)[0];

export default getAssetSubclassFromId;
